/**
 * Keeps the rows whose name or id contains the search text, ignoring case.
 * For lists that are loaded whole, so searching them needs no refetch.
 */
export function filterBySearch<T extends { id: string; name?: string }>(rows: T[], search: string): T[] {
  const term = search.trim().toLowerCase()
  if (!term) return rows
  return rows.filter(
    (row) => row.id.toLowerCase().includes(term) || (row.name ?? '').toLowerCase().includes(term)
  )
}
